export default __webpack_public_path__ + "static/media/bannerHover.14e0a0c2.png";